<template>
    <swiper-slide class="lightbox-gallery-slide">
        <slot></slot>
    </swiper-slide>
</template>

<script>
    import { swiperSlide } from 'vue-awesome-swiper';

    export default {
        components: {
            swiperSlide,
        },
    }
</script>

<style lang="scss" scoped>
    .lightbox-gallery-slide {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// gallery-slide.vue?2b20c4d6